
export default class Term {
    id: number;
    termNumber: number;
    description: string;
    days: number;
}


// WEBPACK FOOTER //
// ./src/models/AP/Term.ts